import React from 'react'

import FirstSection from './FirstSection'
import SecondSection from './SecondSection'
import ThirthSection from './ThirthSection'


import ColorPallet from '../../../../utils/ColorPallet'

function MainSection() {
  return (
    <div className='min-h-screen'>
      {/* First Section */}
      <FirstSection />
      
      {/* Second Section */}
      <div style={{ backgroundColor: ColorPallet.primaryLightBrown }}>
        <SecondSection />
      </div>

      {/* Third Section */}
      <ThirthSection />

    
    </div>
  )
}

export default MainSection